import { lazy, Suspense, useState } from 'react'
import { useAccount, useConnect, useSwitchChain } from 'wagmi'
import { baseSepolia } from 'wagmi/chains'
import { isPrivyEnabled } from '../web3/privyFlag'

const PrivyButton = lazy(() => import('./PrivyWalletButton'))

// Connexion wallet avec sélecteur explicite + erreurs VISIBLES —
// « rien ne se passe » est le pire des bugs.
export default function WalletConnectButton() {
  if (isPrivyEnabled) {
    return (
      <Suspense fallback={null}>
        <PrivyButton />
      </Suspense>
    )
  }
  return <ClassicWalletButton />
}

function ClassicWalletButton() {
  const { isConnected, chainId } = useAccount()
  const { connect, connectors, isPending, error: connectError, reset } = useConnect()
  const { switchChain, isPending: switching, error: switchError } = useSwitchChain()
  const [open, setOpen] = useState(false)

  const error = connectError ?? switchError
  const errorText = error
    ? /reject|denied/i.test(error.message)
      ? 'Connexion refusée dans le wallet'
      : /provider|window\.ethereum|not found|no injected/i.test(error.message)
        ? 'Aucune extension wallet détectée'
        : error.message.split('\n')[0].slice(0, 90)
    : null

  if (!isConnected) {
    // connecteurs dédupliqués par nom (EIP-6963 peut en découvrir plusieurs)
    const list = connectors.filter((c, i, arr) => arr.findIndex((x) => x.name === c.name) === i)
    return (
      <div className="relative">
        <button
          onClick={() => {
            reset()
            if (list.length === 1) connect({ connector: list[0] })
            else setOpen(!open)
          }}
          disabled={isPending}
          className="rounded-full bg-cyber px-3 py-1 text-[11px] font-black uppercase tracking-wide text-carbon transition-transform active:scale-95 disabled:opacity-50"
        >
          {isPending ? 'Connexion…' : '🔗 Wallet'}
        </button>
        {open && (
          <div className="absolute right-0 top-8 z-50 w-48 rounded-xl border border-line bg-panel p-1 shadow-xl">
            {list.map((c) => (
              <button
                key={c.uid}
                onClick={() => {
                  setOpen(false)
                  connect({ connector: c })
                }}
                className="block w-full rounded-lg px-3 py-2 text-left text-xs font-bold text-white/80 hover:bg-white/5"
              >
                {c.name}
              </button>
            ))}
            {list.length === 0 && (
              <p className="px-3 py-2 text-xs text-white/50">
                Aucun wallet — installe MetaMask ou Coinbase Wallet
              </p>
            )}
          </div>
        )}
        {errorText && (
          <p className="absolute right-0 top-8 z-50 w-52 rounded-lg border border-meme/40 bg-panel px-2 py-1 text-[10px] font-bold text-meme">
            ⚠ {errorText}
          </p>
        )}
      </div>
    )
  }

  if (chainId !== baseSepolia.id) {
    return (
      <div className="relative">
        <button
          onClick={() => switchChain({ chainId: baseSepolia.id })}
          disabled={switching}
          className="rounded-full bg-btc px-3 py-1 text-[11px] font-black uppercase tracking-wide text-carbon active:scale-95 disabled:opacity-50"
        >
          ⚠ Passer sur Base Sepolia
        </button>
        {errorText && (
          <p className="absolute right-0 top-8 z-50 w-52 rounded-lg border border-meme/40 bg-panel px-2 py-1 text-[10px] font-bold text-meme">
            ⚠ {errorText}
          </p>
        )}
      </div>
    )
  }

  // connecté sur le bon réseau: rien ici — avatar + modale de profil prennent
  // le relais (adresse et déconnexion y vivent désormais).
  return null
}
